import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import Select from '@adv-mt/mt-form-select'

import {LABELS_BY_OFFER_TYPE_ID} from './config.js'

const LEGACY_WRAPPER = 'legacy'

const FormOfferType = ({
  initialSearch,
  listingSectionId,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value,
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')

  const APP_NAME = config.get('APP_NAME')

  const {offerTypes: defaultOfferTypes, UNSELECTED_OFFER_TYPE, FILTER_NAMES} = config.get('search')

  const {AVAILABLE_OFFER_TYPES_IDS_BY_LISTING_SECTION_ID, AVAILABLE_OFFER_TYPES_IDS_BY_OFFER_TYPE_ID} =
    config.get('searchFilters')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const FIRST_OPTION = {id: UNSELECTED_OFFER_TYPE, label: i18n.t('COMMON.ALL')}

  const offerTypes =
    AVAILABLE_OFFER_TYPES_IDS_BY_LISTING_SECTION_ID[listingSectionId] ||
    AVAILABLE_OFFER_TYPES_IDS_BY_OFFER_TYPE_ID[initialSearch.offerTypeId] ||
    defaultOfferTypes

  const localizedOfferTypes = offerTypes.map(id => ({
    id,
    label: i18n.t(LABELS_BY_OFFER_TYPE_ID[id])
  }))

  const options = [FIRST_OPTION, ...localizedOfferTypes]

  const handleOnChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.OFFER_TYPE,
      value,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.OFFER_TYPE]
    })
  }

  const handleChange = ({value}) => {
    const [selectedValue] = value
    handleOnChange(null, {
      value: Number(selectedValue === filterWrapperBasicAllSelectionsId ? UNSELECTED_OFFER_TYPE : selectedValue)
    })
  }

  const handleReset = () => {
    onChange(null, {
      field: FILTER_NAMES.OFFER_TYPE,
      value: UNSELECTED_OFFER_TYPE
    })
  }

  const label = i18n.t(`FORM_OFFER_TYPE_${APP_NAME}_LABEL`)

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <Select
        field={FILTER_NAMES.OFFER_TYPE}
        initialSearch={initialSearch}
        label={label}
        options={options}
        overlayContentRef={overlayContentRef}
        pageName={pageName}
        value={value}
        onChange={handleOnChange}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {allSelectionsLabel: i18n.t('COMMON.ALL'), name: FILTER_NAMES.OFFER_TYPE, options: localizedOfferTypes, type}
      ]}
      group={`${FILTER_NAMES.OFFER_TYPE}Group`}
      legend={label}
      onChange={handleChange}
      onReset={handleReset}
      overlayContentRef={overlayContentRef}
      placeholder={value === UNSELECTED_OFFER_TYPE ? i18n.t('COMMON.ALL') : i18n.t(LABELS_BY_OFFER_TYPE_ID[value])}
      showLegend={withLabel}
      value={{[FILTER_NAMES.OFFER_TYPE]: [value === UNSELECTED_OFFER_TYPE ? filterWrapperBasicAllSelectionsId : value]}}
      wrapper={wrapper}
    />
  )
}

FormOfferType.displayName = 'FormOfferType'

FormOfferType.propTypes = {
  initialSearch: PropTypes.object,
  listingSectionId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.number,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormOfferType
